import common from './common.json';

export const UA = {
  common,
};
